<script module lang="ts">
  export type System =
    | "sharepoint"
    | "jira"
    | "slack"
    | "github"
    | "confluence"
    | "google-drive"
    | "msgraph-v4"
    | "google-drive-v1.0.0";
</script>

<script lang="ts">
  import SlackLogo from "$assets/icons/slack.svelte";
  import SharepointLogo from "$assets/icons/sharepoint.svelte";
  import JiraLogo from "$assets/icons/jira.svelte";
  import GithubLogo from "$assets/icons/github.svelte";
  import ConfluenceLogo from "$assets/icons/confluence.svelte";
  import GoogleLogo from "$assets/icons/google-logo.svelte";

  let { system } = $props<{ system: System }>();
</script>

<div class="w-12 h-12 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center">
  <span class="w-6 h-6">
    {#if system === "sharepoint" || system.startsWith("msgraph")}
      <SharepointLogo />
    {:else if system === "google-drive" || system.startsWith("google")}
      <GoogleLogo />
    {:else if system === "jira"}
      <JiraLogo />
    {:else if system === "slack"}
      <SlackLogo />
    {:else if system === "github"}
      <GithubLogo />
    {:else if system === "confluence"}
      <ConfluenceLogo />
    {/if}
  </span>
</div>
